const { checkNotEmpty } = require("./common");

export const Warning = (objs, sweet) => {
    sweet
        .fire({
            imageUrl:
                objs["state"] == "info" ? require("@/assets/images/InformV2.png") :
                    objs["state"] == "error"
                        ? require("@/assets/images/ErrorV2.png")
                        : require("@/assets/images/Warning.png"),
            position: "bottom",
            title: checkNotEmpty(objs["title"]) ? objs["title"] : "",
            html: checkNotEmpty(objs["message"]) ? objs["message"] : "",
            padding: "0",
            showConfirmButton: checkNotEmpty(objs["confirmButtonText"]),
            showCancelButton: checkNotEmpty(objs["cancelButtonText"]),
            confirmButtonText: checkNotEmpty(objs["confirmButtonText"])
                ? objs["confirmButtonText"]
                : "ใช่",
            cancelButtonText: checkNotEmpty(objs["cancelButtonText"])
                ? objs["cancelButtonText"]
                : "ไม่ใช่",
            confirmButtonColor: "#00A3E4",
            reverseButtons: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttonsStyling: false,
            customClass: {
                title:
                    "swal-title-warning font-anuphan-bold-16 text-revamp-color-black",
                confirmButton: `btn btn-info font-anuphan-bold-16 btn-ktb-WEB-v2 btn-swal-width btn-ktb-WEB-confirm-v2 nowrap-text ${objs["state"] == "error" || objs["cancelButtonText"] === ""
                    ? "btn-swal-width-100-popup-haft"
                    : ""
                    }`,
                cancelButton:
                    "btn btn-info btn-ktb-WEB-v2 font-anuphan-bold-16 btn-swal-width btn-ktb-WEB-cancle-v2",
                popup: "swal2-modal-WEB swal2-revamp-popup",
                image: "swal2-image-WEB-v2",
                htmlContainer:
                    "html-container-warning text-revamp-color-grey font-anuphan-regular-14",
                container: "custom-swal2-backdrop-show",
            },
        })
        .then((result) => {
            if (result.isConfirmed && checkNotEmpty(objs["confirmCallBack"])) {
                objs["confirmCallBack"]();
            }
        });
};

export const WarningWithCallback = (objs, sweet) => {
    sweet
        .fire({
            imageUrl:
                objs["state"] == "info" ? require("@/assets/images/InformV2.png") :
                    objs["state"] == "error"
                        ? require("@/assets/images/ErrorV2.png")
                        : require("@/assets/images/Warning.png"),
            position: "bottom",
            title: checkNotEmpty(objs["title"]) ? objs["title"] : "",
            html: checkNotEmpty(objs["message"]) ? objs["message"] : "",
            padding: "0",
            showConfirmButton: checkNotEmpty(objs["confirmButtonText"]),
            showCancelButton: checkNotEmpty(objs["cancelButtonText"]),
            confirmButtonText: checkNotEmpty(objs["confirmButtonText"])
                ? objs["confirmButtonText"]
                : "ใช่",
            cancelButtonText: checkNotEmpty(objs["cancelButtonText"])
                ? objs["cancelButtonText"]
                : "ไม่ใช่",
            confirmButtonColor: "#00A3E4",
            reverseButtons: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttonsStyling: false,
            customClass: {
                title:
                    "swal-title-warning font-anuphan-bold-16 text-revamp-color-black",
                confirmButton: `btn btn-info font-anuphan-bold-16 btn-ktb-WEB-v2 btn-swal-width btn-ktb-WEB-confirm-v2 nowrap-text ${objs["state"] == "error" || objs["cancelButtonText"] === ""
                    ? "btn-swal-width-100-popup-haft"
                    : ""
                    }`,
                cancelButton:
                    "btn btn-info btn-ktb-WEB-v2 font-anuphan-bold-16 btn-swal-width btn-ktb-WEB-cancle-v2",
                popup: "swal2-modal-WEB swal2-revamp-popup",
                image: "swal2-image-WEB-v2",
                htmlContainer:
                    "html-container-warning text-revamp-color-grey font-anuphan-regular-14",
                container: "custom-swal2-backdrop-show",
            },
        })
        .then((result) => {
            if (checkNotEmpty(objs["confirmCallBack"])) {
                objs["confirmCallBack"](result);
            }
        });
};

export const WarningPassword = (objs, sweet, ctx, tmpFile) => {
    return sweet
        .fire({
            position: "bottom",
            title: "กรุณาระบุรหัสผ่านเอกสาร",
            html: messagePopupPassword(objs["message"]),
            padding: "0",
            showConfirmButton: false,
            showCancelButton: false,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            confirmButtonColor: "#00A3E4",
            reverseButtons: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            buttonsStyling: false,
            customClass: {
                title:
                    "swal-title-warning font-anuphan-bold-16 text-revamp-color-black",
                confirmButton: `btn btn-info font-anuphan-bold-16 btn-ktb-WEB-v2 btn-swal-width ${objs["state"] == "error" ? "btn-swal-width-100-popup-haft" : ""
                    }`,
                cancelButton:
                    "btn btn-info btn-ktb-WEB-v2 font-anuphan-bold-16 btn-swal-width btn-ktb-WEB-cancle-v2",
                popup: "swal2-modal-WEB revamp-swal2-popup-padding-password",
                image: "swal2-image-WEB-v2",
                htmlContainer:
                    "html-container-warning text-revamp-color-grey font-anuphan-regular-14 swal2-html-container-remove-margin",
                container: "custom-swal2-backdrop-show",
            },
            didOpen: async () => {
                ctx.isPassword = true;
                ctx.showPassword = false;
                const confirmBtn = document.getElementById("buttonConfirm");
                const passwordInputEl = document.getElementById("passwordInput");
                const passwordInputLabel =
                    document.getElementById("passwordInputLabel");
                const eyeIcon = document.getElementById("eyeIcon");
                const eyeClosedIcon = document.getElementById("eyeClosedIcon");
                const toggleEye = document.getElementById("toggleEye");
                const eyeClosedIconSvg = document.getElementById("eyeClosedIconSvg");
                const eyeIconSvg = document.getElementById("eyeIconSvg");

                passwordInputLabel.style.display = "none";

                const setEye = (status) => {
                    // console.log("status", status);
                    if (status) {
                        eyeClosedIcon.style.display = "block";
                        eyeIcon.style.display = "none";
                        passwordInputEl.type = "text";
                        passwordInputEl.style.fontSize = "16px";
                    } else {
                        eyeClosedIcon.style.display = "none";
                        eyeIcon.style.display = "block";
                        passwordInputEl.type = "password";
                        passwordInputEl.style.fontSize = "24px";
                    }
                };

                setEye(ctx.showPassword);

                const applyDisabledStyle = (disabled) => {
                    confirmBtn.disabled = disabled;
                    confirmBtn.style.backgroundColor = "#E5E7EB";
                    confirmBtn.style.border = "1px solid #E5E7EB";
                    confirmBtn.style.color = "#9CA3AF";
                };
                applyDisabledStyle(true);

                passwordInputEl.addEventListener("input", (event) => {
                    // console.log("Current value:", event.target.value);
                    if (event.target.value.length > 0) {
                        confirmBtn.disabled = false;
                        confirmBtn.style.backgroundColor = "#015AF5";
                        confirmBtn.style.border = "1px solid #015AF5";
                        confirmBtn.style.color = "#FFFF";
                    } else {
                        confirmBtn.disabled = true;
                        confirmBtn.style.backgroundColor = "#E5E7EB";
                        confirmBtn.style.border = "1px solid #E5E7EB";
                        confirmBtn.style.color = "#9CA3AF";
                    }
                });

                confirmBtn.addEventListener("click", async () => {
                    // console.log("Click close:");
                    const res = await ctx.validateFileHavePassword(
                        tmpFile,
                        passwordInputEl.value
                    );
                    if (res === null) {
                        // Handle button
                        confirmBtn.disabled = true;
                        confirmBtn.style.backgroundColor = "#E5E7EB";
                        confirmBtn.style.border = "1px solid #E5E7EB";
                        confirmBtn.style.color = "#9CA3AF";
                        // Show label
                        passwordInputLabel.style.display = "block";
                        // Handle input error
                        passwordInputEl.classList.remove("no-border-input");
                        passwordInputEl.classList.add("no-border-input-error");
                        // passwordInputEl.style.borderColor = "#e02424";
                        // passwordInputEl.style.color = "#e02424";
                        // Handle icon
                        eyeClosedIconSvg
                            .querySelectorAll("path")
                            .forEach((p) => p.setAttribute("stroke", "#e02424"));
                        eyeIconSvg
                            .querySelectorAll("path")
                            .forEach((p) => p.setAttribute("stroke", "#e02424"));
                    } else {
                        // console.log("res", res.password);
                        objs["confirmCallBack"](res);
                        sweet.close();
                    }
                });

                document
                    .getElementById("buttonCalcle")
                    .addEventListener("click", () => {
                        sweet.close();
                    });

                toggleEye.addEventListener("click", () => {
                    // console.log("ctx.showPassword", ctx.showPassword);
                    ctx.showPassword = !ctx.showPassword;
                    setEye(ctx.showPassword);
                });
            },
        })
        .then((result) => {
            if (result.isConfirmed && checkNotEmpty(objs["confirmCallBack"])) {
                // objs["confirmCallBack"]();
            }
        });
};

const messagePopupPassword = (filename) => {
    return `<div style="display: flex; flex-direction: column; position: relative;">
        <div class="font-anuphan-regular-14 text-revamp-color-black" style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 10px;">
            ${filename}
        </div>
        <ul style="text-align: left; margin-top: 10px;" class="font-anuphan-regular-14 text-revamp-color-grey">
            <li id="passwordMarker">ตรวจสอบรหัสผ่านทางอีเมลที่คุณได้รับเอกสาร รหัสอาจเป็น เลขบัตรประชาชน หรือ วันเดือนปีเกิด</li>
            <li id="passwordMarker">รหัสใช้สำหรับเปิดดูเอกสารเพื่อการพิจารณา สินเชื่อเท่านั้น</li>
        </ul>
        <div style="position: relative; width: 100%; margin-top: 20px;">
            <input id="passwordInput" style="width: 98%; height: 56px; border-radius: 16px;" type="password" class="no-border-input" />
            <div id="toggleEye" style="position: absolute; top: 30%; right: 5%;">
                <span id="eyeClosedIcon">
                    <svg id="eyeClosedIconSvg" width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.74294 3.09232C10.1494 3.03223 10.5686 3 11.0004 3C16.1054 3 19.4553 7.50484 20.5807 9.28682C20.7169 9.5025 20.785 9.61034 20.8231 9.77667C20.8518 9.90159 20.8517 10.0987 20.8231 10.2236C20.7849 10.3899 20.7164 10.4985 20.5792 10.7156C20.2793 11.1901 19.8222 11.8571 19.2165 12.5805M5.72432 4.71504C3.56225 6.1817 2.09445 8.21938 1.42111 9.28528C1.28428 9.50187 1.21587 9.61016 1.17774 9.77648C1.1491 9.9014 1.14909 10.0984 1.17771 10.2234C1.21583 10.3897 1.28393 10.4975 1.42013 10.7132C2.54554 12.4952 5.89541 17 11.0004 17C13.0588 17 14.8319 16.2676 16.2888 15.2766M2.00042 1L20.0004 19M8.8791 7.87868C8.3362 8.42157 8.00042 9.17157 8.00042 10C8.00042 11.6569 9.34356 13 11.0004 13C11.8288 13 12.5788 12.6642 13.1217 12.1213" stroke="#015AF5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span id="eyeIcon">
                    <svg id="eyeIconSvg" width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.42012 8.71318C1.28394 8.49754 1.21584 8.38972 1.17772 8.22342C1.14909 8.0985 1.14909 7.9015 1.17772 7.77658C1.21584 7.61028 1.28394 7.50246 1.42012 7.28682C2.54553 5.50484 5.8954 1 11.0004 1C16.1054 1 19.4553 5.50484 20.5807 7.28682C20.7169 7.50246 20.785 7.61028 20.8231 7.77658C20.8517 7.9015 20.8517 8.0985 20.8231 8.22342C20.785 8.38972 20.7169 8.49754 20.5807 8.71318C19.4553 10.4952 16.1054 15 11.0004 15C5.8954 15 2.54553 10.4952 1.42012 8.71318Z" stroke="#015AF5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11.0004 11C12.6573 11 14.0004 9.65685 14.0004 8C14.0004 6.34315 12.6573 5 11.0004 5C9.34355 5 8.0004 6.34315 8.0004 8C8.0004 9.65685 9.34355 11 11.0004 11Z" stroke="#015AF5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
            </div>
        </div>
        <p id="passwordInputLabel" style="width: 100%; text-align: start;" class="text-revamp-color-danger font-anuphan-regular-14 mt-2">รหัสผ่านไม่ถูกต้อง</p>
        <div style="display: flex; margin-top: 20px;">
            <button id="buttonCalcle" style="width: 100%;" class="swal2-cancel btn btn-info btn-ktb-WEB-v2 font-anuphan-bold-16 btn-swal-width btn-ktb-WEB-cancle-v2">ยกเลิก</button>
            <button id="buttonConfirm" style="width: 100%; background-color: #015AF5;" class="swal2-confirm btn btn-info font-anuphan-bold-16 btn-ktb-WEB-v2 btn-swal-width">ยืนยัน</button>
        </div>
    </div>`;
};
